import type { WaterlyAppStateCreator } from "./waterlyAppStateCreator.type";

type EditModeState = {
  editMode: boolean;
};

type EditModeActions = {
  toggleEditMode: () => void;
  resetEditMode: () => void;
};

const initialState: EditModeState = {
  editMode: false,
};

export const createEditModeSlice: WaterlyAppStateCreator<EditModeActions, EditModeState> = (set, get) => ({
  ...initialState,
  toggleEditMode: () => {
    const { editMode } = get();
    set({ editMode: !editMode });
  },
  resetEditMode: () => {
    set(initialState);
  },
});
